export class Note {
    created: Date;
    username: string;
    text: string;
    new: boolean;
    noteTypeId: number;
    noteType: string;
    noteDetails: string; 
    showInFinance: boolean;
    completedBy: string;

    constructor(username: string, text: string, noteType: string) {
        this.created = new Date();
        this.username = username;
        this.text = text;
        this.new = true;
        this.noteType = noteType;
    }
}
